import React, { useState, useEffect, useRef } from "react";
import ApiCaller from "api/apiCaller";
import "./index.scss";
import Select from "react-select";
import t from "utils/Lang";

const FollowerManager = ({ followers, contentType, contentId, users }) => {
  let defaultFollowers = [];
  if (followers) {
    followers.map((follower) => {
      defaultFollowers.push({
        value: follower.id,
        label: `${follower.first_name} ${follower.last_name}`,
      });
    });
  }
  const selectRef = useRef(null);
  const [isSelectDisabled, setIsSelectDisabled] = useState(true);
  const [currentFollowers, setCurrentFollowers] = useState(defaultFollowers);
  const updateFollowingUsers = async () => {
    let bodyToSubmit = {};
    if (!currentFollowers || currentFollowers.length <= 0) {
      bodyToSubmit = {
        user_ids: [],
      };
    } else {
      bodyToSubmit = {
        user_ids: currentFollowers.map((currentFollower) => {
          return currentFollower.value;
        }),
      };
    }
    const res = await ApiCaller.post(
      `follower/${contentType}/${contentId}`,
      bodyToSubmit
    );
    if (res.status === "ok") {
      setIsSelectDisabled(true);
    }
  };
  const selectUserFollowing = (selectedUsers) => {
    setCurrentFollowers(selectedUsers);
  };
  const toogleEditMode = () => {
    if (isSelectDisabled) {
      setIsSelectDisabled(false);
    } else {
      setIsSelectDisabled(true);
    }
  };
  const saveFollowers = () => {
    updateFollowingUsers();
  };
  return (
    <div>
      <div style={styles.header}>
        <span className="follower-title">{t().site_detail__follower}</span>
        {!isSelectDisabled ? (
          <span style={styles.editFollowers} onClick={saveFollowers}>
            {t().action__save}
          </span>
        ) : (
          <span style={styles.editFollowers} onClick={toogleEditMode}>
            {t().action__edit}
          </span>
        )}
      </div>
      <Select
        isMulti
        isDisabled={isSelectDisabled}
        options={users}
        value={currentFollowers}
        onChange={(selectedUsers) => setCurrentFollowers(selectedUsers)}
      />
    </div>
  );
};

const styles = {
  header: {
    marginBottom: 6,
  },
  editFollowers: {
    color: "var(--primary)",
    marginLeft: 12,
    cursor: "pointer",
  },
};

export default FollowerManager;
